import React from "react";
import {Link} from "react-router-dom";
import {jobOverviewSnapshot} from "./jobOverviewModel";
import {Thumbnail} from "./BannerDesigns";
import ProductionCounter from "./ProductionCounter";

const skipped=new Set(["Workflow","Linked photo appointment","Previous design source"]);
const empty=new Set(["Not recorded","No date supplied","No linked photo appointment"]);

export default function SimpleJobOverview({job,items,designs,approvals,appointment,loading,error}) {
  if(loading)return <p role="status">Loading job summary...</p>;
  if(error)return <p role="alert">{error}</p>;
  const summary=jobOverviewSnapshot({job,items,designs,approvals,appointment});
  return <section className="banner-simple-overview" aria-label="Simple job overview">
    <div className="banner-overview-grid">
      <section><h3>Job summary</h3><dl className="banner-summary-details">{summary.details.filter(([label,value])=>!skipped.has(label) && value && !empty.has(value)).map(([label,value])=><div key={label}><dt>{label}</dt><dd>{value}</dd></div>)}</dl>
        {job.appointmentId && <Link to="/scheduler" state={{appointmentId:job.appointmentId}}>Open linked photo appointment</Link>}
        {job.basis==="previous" && job.previousJobId && <p><Link to={`/banners/${job.previousJobId}`}>Previous design source</Link></p>}
      </section>
      <section><h3>Selected design</h3><p>{summary.design.status}</p>{summary.design.path && <Thumbnail path={summary.design.path} label={"Selected design: "+summary.design.label}/>}{summary.design.label && <p><strong>{summary.design.label}</strong>{summary.design.year ? " / "+summary.design.year : ""}</p>}
        <h3>Job needs</h3>{summary.needs.length ? <ul className="banner-needs">{summary.needs.map(([label,size,payment],index)=><li key={index}><strong>{label}</strong>{" — "}{size}<p>Payment: {payment}</p></li>)}</ul> : <p>No job needs recorded.</p>}
      </section>
    </div>
    {job.notes?.trim() && <section><h3>Written notes</h3><p className="banner-summary-notes">{summary.notes}</p></section>}
    {job.appointmentId && <section><h3>Banner info from linked photo appointment</h3><p className="banner-summary-notes">{summary.appointmentInfo}</p></section>}
    <ProductionCounter appointmentId={job.appointmentId} appointment={appointment}/>
  </section>;
}
